###
    @author Jaromír Navara [BG] <web@bagricek.cz>
    26.8.2016 4:14
###
(($, window) ->
  'use strict'
  # Define the plugin class
  class Trideni
    $el: false
    rawPieces: {}, pieces: [], DOMPieces: []
    timer: 0, timerInterval: null, timeSpent: 0, points: 0, matchedCount: 0, isFreezedTimer: false
    options: {}
    isFirstClick: true
    ion: null
    type: null, points: 0

    constructor: (el, options) ->
      @debug("construct");
      @options = options
      @type = options.type
      @$el = $(el)
      @init()

    debug: (msg)->
      if(@options.debug)
        console.log msg

    init: ->
      @debug("init");
      $(".games.row").height("auto")
      @shufflePieces()
      @_initDroppable()
      @_initDraggable()
      #if @type == "time"
      @initPauseTimer()
      @startTimer()

    shufflePieces: ->
      $items = @$el.find("#items")
      topOffset = parseInt($items.position().top)
      bottom = parseInt($(window).height()) - parseInt($items.offset().top) + topOffset
      console.info(itemsTop: topOffset, bottom: bottom);

      wrapperWidth = parseInt $("#content-wrapper").width()
      generateNumber = @_getRandomNumber
      $items.find("span").each ->
        $self = $(this)
        height = parseInt $self.height()

        width = parseInt $self.width()
        $(this).css
          top: generateNumber(topOffset, bottom - height)
          left: generateNumber(1, wrapperWidth - width)

    _getRandomNumber: (min,max) ->
      Math.floor(Math.random()*(max-min+1)+min)

    _initDroppable: ->
      self = this
      @$el.find("#kontejnery .kontejner").droppable
        drop: (e,ui) ->
          targetContainerId = $(ui.draggable).data "kontejner"
          containerId = $(this).data "id"
          if targetContainerId == containerId
            # success
            self.dropSuccess()
          else
            # fail
            self.dropFail()
          if self.type != "time"
            self.refreshPoints()


    dropSuccess: ->
      @points += 10

    dropFail: ->
      @points -= 1

    _initDraggable: ->
      self = this
      @$el.find("#items span").draggable
        #containment: "#content-wrapper"
        revert: (e) ->
          if e
            matchContainer = $(this).data "kontejner"
            if "kontejner-#{matchContainer}" == e[0].id
              if ion.muted == false
                ion.sound.play("sound_match")
              $(this).fadeOut ->
                $(this).remove()
                self.checkWin()
                "valid"
            else
              if ion.muted == false
                ion.sound.play("sound_nomatch")
              "invalid"
          else
            false

    onFirstclick: ->
      $.ajax
        url:   @options.startTimerUrl,
        type: "GET"

    endgameAnimation: (redirect)=>
      $el = @$el
      $elemsForAnimation = $el.find(".kontejner:has(img.full)");

      width = $elemsForAnimation.find("img.empty").first().width()

      $elemsForAnimation.find("img.empty").fadeOut ->
        if $elemsForAnimation.length > 0
          $elemsForAnimation.find("img.full").width(width).fadeIn ->
            setTimeout ->
              location.href = redirect
            , 2000
        else
          location.href = redirect

    stopTimer: (redirect = null)->
      endGame = @endgameAnimation
      $.ajax
        url:   @options.stopTimerUrl,
        type: "GET",
        data: {points: @points}
        success: ->
          if(redirect != null)
            endGame(redirect)

    checkWin: ->
      # has won?
      if $("#items span").length == 0
        @clearTimer()
        if ion.muted == false
          ion.sound.stop("sound_music")
          ion.sound.play("sound_semivictory")
        @stopTimer(@options.victoryPage)

    startTimer: ->
      @debug("startTimer")
      @clearTimer()
      $("#navigation_pause").slideDown()
      $.ajax
        url:   @options.startTimerUrl,
        type: "GET"
      @timerInterval = setInterval =>
        if(!@isFreezedTimer)
          @timer++
          @timeSpent++
          if @type == "time"
            @renderTimeSpent()
        #@debug("timer: #{@timer}")
      , 1000

    clearTimer: ->
      clearInterval @timerInterval

    initPoints: ->


    initPauseTimer: ->
      @debug "initPauseTimer"
      $("#navigation_pause").click (e)=>
        @debug "navigation_pause click"
        @debug $(e.target)
        @isFreezedTimer = !@isFreezedTimer
        $button = $(e.target)
        $button.toggleClass("navigation_play")
        $button.toggleClass("navigation_pause")
        $("#overlay").fadeToggle()

    givePoints: ->

    refreshPoints: ->
      $("#points #value").text(@points + " bodů")

    renderTimeSpent: ->
      #@debug "renderTimeSpent"
      minutes = Math.floor( @timeSpent/60 )
      seconds = Math.floor( @timeSpent - (minutes*60) )
      if(minutes < 10)
        minutes = "0" + minutes
      if(seconds < 10)
        seconds = "0" + seconds
      $("#points #value").text "#{minutes}:#{seconds}"



  # Define the plugin
  $.fn.extend Trideni: (option, args...) ->
    @each ->
      $this = $(this)
      data = $this.data('Trideni')

      if !data
        $this.data 'Trideni', (data = new Trideni(this, option))
      if typeof option == 'string'
        data[option].apply(data, args)

) window.jQuery, window